import { useTranslation } from "react-i18next";

export default function Clients() {
  const { t } = useTranslation();

  return (
    <div id="clients" className="border-y border-outline-variant/30 py-12 bg-white/50 backdrop-blur-sm scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-[10px] font-bold text-on-surface-variant uppercase tracking-[0.3em] mb-10">
          {t('clients.title')}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 opacity-70 grayscale hover:grayscale-0 transition-all duration-700">
          {[
            { name: "ASYA ERP", img: "/client/logo-asya.png" },
            { name: "Araya", img: "/client/araya.png" },
            { name: "Jaraya", img: "/client/jaraya.jpg" },
            { name: "Prahwa", img: "/client/prahwa.jpg" },
            { name: "CodeLite", img: "/client/codelite.png" },
            { name: "SIS", img: "/client/logo-sis.png" },
            { name: "Indopelita", img: "/client/logogram-ias.png" },
            { name: "Salma Food", img: "/client/salmafood.webp" },
            { name: "Insan Optima Teknik", img: "/client/indopelita.webp" },
          ].map((client) => (
            <div key={client.name} className="flex flex-col items-center gap-2 group cursor-default">
              <div className="w-16 h-16 flex items-center justify-center rounded-lg group-hover:scale-110 transition-all">
                <img 
                  src={client.img} 
                  alt={client.name} 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-[11px] font-bold tracking-tight text-on-surface-variant group-hover:text-on-surface transition-colors text-center">
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}